<dx-data-grid
  #channelsGrid
  [dataSource]="(marketingChannels$ | async) || []"
  keyExpr="id"
  [showBorders]="false"
  [showColumnLines]="false"
  [showRowLines]="true"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  [allowColumnResizing]="true"
  [columnResizingMode]="'nextColumn'"
  [paging]="{ enabled: true }"
  [scrolling]="{
    mode: 'standard',
    showScrollbar: 'always',
    useNative: false,
    scrollByThumb: true,
    scrollByContent: true
  }"
  (onInitNewRow)="onChannelAddingStart()"
  (onEditingStart)="onChannelEditingStart()"
  (onRowInserted)="onChannelInserted($event)"
  (onRowUpdating)="onChannelUpdating($event)"
  (onRowRemoving)="onChannelRemoving($event)"
>
  <dxo-toolbar>
    <dxi-item location="after">
      <div *dxTemplate>
        <dx-text-box
          #searchBoxInput
          icon="search"
          [width]="250"
          [placeholder]="'COMMON.SEARCH' | translate"
          stylingMode="outlined"
          valueChangeEvent="input"
          (onValueChanged)="onChannelSearch($event)"
          class="search-box"
        >
          <dxi-button
            name="search"
            type="danger"
            location="before"
            [options]="{ 
              icon: 'search', 
              type: 'default', 
              disabled: true 
            }"
          ></dxi-button>
        ></dx-text-box>
      </div>
    </dxi-item>
  </dxo-toolbar>

  <dxo-paging
    [enabled]="true"
    [pageSize]="10"
  ></dxo-paging>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[5, 10, 20]"
    [showInfo]="true"
  ></dxo-pager>

  <dxo-editing
    mode="popup"
    [allowUpdating]="true"
    [allowAdding]="false"
    [allowDeleting]="true"
    [useIcons]="true"
    [texts]="{
      saveRowChanges: ('COMMON.SAVE' | translate),
      cancelRowChanges: ('COMMON.CANCEL' | translate),
      confirmDeleteTitle: ('CHANNELS.DELETE-CHANNEL.TITLE' | translate),
      confirmDeleteMessage: ('CHANNELS.DELETE-CHANNEL.TEXT' | translate)
    }"
  >
    <dxo-popup
      [title]="channelEditPopupTitle"
      [showTitle]="true"
      [width]="400"
      [height]="250"
      [dragEnabled]="false"
      [hideOnOutsideClick]="true"
    ></dxo-popup>

    <dxo-form>
      <dxi-item dataField="name">
        <dxo-label
          [text]="'COMMON.FIELDS.NAME' | translate"
        ></dxo-label>

        <dxi-validation-rule
          type="required"
          [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxi-column
    dataField="name"
    [caption]="'COMMON.FIELDS.NAME' | translate"
  ></dxi-column>
</dx-data-grid>